import { memo, useEffect, useState, useCallback } from 'react'
import Backdrop from '@mui/material/Backdrop'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

import SocietyCoinABI from '../abis/NeonTigerSociety.json';
import ERC20ABI from '../abis/ERC20.json';
import GoldTokenABI from '../abis/GoldToken.json';
import GoldPoolABI from '../abis/GoldPool.json';
import SocietyH2OABI from '../abis/SocietyH2O.json';
import Staking_SctyH2OABI from '../abis/Staking_SctyH2O.json';
import StackLv1NoblestackABI from '../abis/StackLv1NobleStacks.json';
import P2pSwapLv1NoblestackABI from '../abis/P2PSwapLv1NobleStack.json';
import LV1NobleStackABI from "../abis/Lv1NobleStack.json";
import SocietykeyABI from '../global/SocietyKey.json'
import SocietyCoinabi from '../global/SocietyCoin.json'
import { Interface } from '@ethersproject/abi'
import { Contract } from '@ethersproject/contracts'

import {
    SocietyCoinContract,
    NobleSwapContract,
    StackLv1Noblestack,
    StackLv2Noblestack,
    StackLv3Noblestack,
    StackLv4Noblestack,
    LV1NobleStack,
    LV2NobleStack,
    LV3NobleStack,
    LV4NobleStack,
    P2pSwapLv1Noblestack,
    P2pSwapLv2Noblestack,
    P2pSwapLv3Noblestack,
    P2pSwapLv4Noblestack,
    P2pSwapSocietyCoin,
    UsdcAdress,
    GoldAddress,
    PoolAddress,
    SocietyKeyContract
} from '../global/constants'

import { BIG_ZERO } from '../global/constants'
import useEstimateGas from '../hooks/useEstimateGas'

import './card.scss'
import { getProviderOrSigner } from '../hooks/useContract'
import { useEthers, TransactionStatus } from '@usedapp/core';
import { ethers } from 'ethers';
import { toast } from 'react-toastify';
import { Grid } from '@mui/material';

const PageSlider = (props: { level: number }) => {
    let level: number = props.level;
    //let cntLevel: number = parseInt(props.cntLevel);
    let marks1: string[] = [
        "0", "1X", "2X", "3X"
    ];
    const marks2: string[] = ["", "$333 MINIMUM", "$1111 MINIMUM", "$4444 MINIMUM"];
    let data: number[] = [0, 0, 0];
    return (
        <>
            <Grid container>
                <Grid item xs={3 * level}></Grid>
                <Grid item xs={3} style={{ textAlign: 'RIGHT' }}>
                    <p style={{ margin: '0px 0' }}></p>
                    <img src="./img/LittleKnights.PNG" style={{ width: '50%' }} />
                </Grid>
            </Grid>
            <Grid container columns={24} style={{ height: '10px' }}>
                <Grid item xs={3}></Grid>
                <Grid item xs={18}>
                    <svg width="100%" height="100%" style={{ overflow: 'initial' }}>
                        <line x1="5" y1="5" x2="100%" y2="5" style={{ stroke: 'rgb(155,155,155)', strokeWidth: '0' }} />
                        <line x1={`${level * 33}%`} y1="5" x2="0" y2="5" style={{ stroke: 'rgb(255, 255, 255)', strokeWidth: '3' }} />
                        <circle cx="5" cy="5" r="4" stroke="white" stroke-width="1" fill="white" />
                        <circle cx="33%" cy="5" r="4" stroke="white" stroke-width="1" fill="white" />
                        <circle cx="66%" cy="5" r="4" stroke="white" stroke-width="1" fill="white" />
                        <circle cx="99%" cy="5" r="4" stroke="white" stroke-width="1" fill="white" />
                    </svg>
                </Grid>
                <Grid item xs={3}></Grid>


            </Grid>
            <Grid container style={{ color: '#fff', marginTop: "10px" }}>
                {
                    marks1.map((data: string, index) => {
                        let color = "#fff";
                        if (index > level) color = "#999";
                        return <Grid item xs={3} style={{ color: color, textAlign: "CENTER" }}><p style={{
                            color: '#DAA520',
                            fontSize: '1.3em',
                        }} className="card-title1">{data}</p><p style={{ fontSize: '1.2em' }} className="card-title">{marks2[(index)]}</p></Grid>
                    })
                }
            </Grid>

        </>
    )
}


const P2pSwapSocietyCard = () => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#000000',
        border: '1px solid #ffffff55',
        borderRadius: '30px',
        boxShadow: 24,
        p: 4,
    }

    const SwapType = {
        usdc: 'USDC',
        key: 'SOCIETYKEY'
    }


    const { account, library } = useEthers()
    const [posAmount, setPosAmount] = useState<any>(BIG_ZERO)
    const [stackAddress, setStackAddress] = useState(StackLv1Noblestack);
    const [posAddress, setPosAddress] = useState(SocietyCoinContract);
    const [p2pAddress, setP2pAddress] = useState(P2pSwapSocietyCoin);
    const [swapAddress, setSwapAddress] = useState(UsdcAdress);
    const [ratio, setRatio] = useState("19:1");
    const [level, setLevel] = useState(1);
    const [contractBalance, setContractBalance] = useState<any>(BIG_ZERO);
    const [balance, setBalance] = useState<any>(BIG_ZERO);
    const [approvedGOLD, setApprovedGOLD] = useState(false);
    const [approvedUsdc, setApprovedUsdc] = useState(false);
    const [swapIn, setSwapIn] = useState(SwapType.usdc);

    const changeSwapIn = (swapType: any) => {
        let addr = UsdcAdress;
        if (swapType == SwapType.key) {
            addr = SocietyKeyContract;
        }
        setSwapAddress(addr);
        setSwapIn(swapType);
    }

    const copycontract = './img/copycontract.png';
    const [opena, setOpena] = useState(false)
    const [claimAddress, setClaimAddress] = useState('')
    const [swapAmount, setSwapAmount] = useState('')
    const handleOpena = () => setOpena(true)
    const handleClosea = () => setOpena(false)

    const [openb, setOpenb] = useState(false)
    const handleOpenb = () => setOpenb(true)
    const handleCloseb = () => setOpenb(false)

    const [openc, setOpenc] = useState(false)
    const handleOpenc = () => setOpenc(true)
    const handleClosec = () => setOpenc(false)

    const [opend, setOpend] = useState(false)
    const handleOpend = () => setOpend(true)
    const handleClosed = () => setOpend(false)

    const [opene, setOpene] = useState(false)
    const handleOpene = () => setOpene(true)
    const handleClosee = () => setOpene(false)

    const [societyLevelVal, setSocietyLevelval] = useState(1)

    const copyAddress = () => {
        navigator.clipboard.writeText(posAddress);
        toast.success('Copied',
            {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true,
            })
    }

    const setLevelDetail = (lvl: any) => {
        if (lvl == 1) {
            setLevel(1)
            setRatio("19:1")
            setStackAddress(StackLv1Noblestack)
            setPosAddress(LV1NobleStack)
            setP2pAddress(P2pSwapSocietyCoin);
        } else if (lvl == 2) {
            setLevel(2)
            setRatio("19:2")
            setStackAddress(StackLv2Noblestack)
            setPosAddress(LV2NobleStack)
            setP2pAddress(P2pSwapLv2Noblestack);
        } else if (lvl == 3) {
            setLevel(3)
            setRatio("19:3")
            setStackAddress(StackLv3Noblestack)
            setPosAddress(LV3NobleStack)
            setP2pAddress(P2pSwapLv3Noblestack);
        } else if (lvl == 4) {
            setLevel(4)
            setRatio("19:4")
            setStackAddress(StackLv4Noblestack)
            setPosAddress(LV4NobleStack)
            setP2pAddress(P2pSwapLv4Noblestack);
        }
    }

    const showError = (error: any) => {
        console.log(error)
        if (error.error) {
            toast.error(
                error.error.data.message
                    .split('execution reverted: ')
                    .join(''),
                {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    hideProgressBar: true,
                },
            )
        }
        else {
            toast.error("Eror: error rejection", {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true,
            })
        }
    }


    //approve GOLD for sell
    const approveGOLD = async () => {
        try {
            const goldContract = new Contract(GoldAddress, new Interface(ERC20ABI.abi), getProviderOrSigner(library, account));
            await goldContract.approve(PoolAddress, ethers.constants.MaxUint256).then((tx: any) => {
                tx.wait().then((res: any) => {
                    setApprovedGOLD(true)
                    toast.success('Approve successful', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    })
                })
            })
        } catch (error) {
            showError(error);
        }
    }

    //approve USDC for buy GOLD
    
const approveUsdc = async (usdcAmountToApprove: string) => {
    try {
        const usdcContract = new Contract(UsdcAdress, new Interface(ERC20ABI.abi), getProviderOrSigner(library, account));
        const amount = ethers.utils.parseUnits(usdcAmountToApprove, 6); // 6 decimals for USDC
        await usdcContract.approve(PoolAddress, amount).then((tx: any) => {
            tx.wait().then((res: any) => {
                setApprovedUsdc(true);
                toast.success('Approve successful', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    hideProgressBar: true,
                })
            })
        })
    } catch (error) {
        showError(error);
    }
}




    const deposit = async () => {
        try {
            const p2pContract = new Contract(p2pAddress, new Interface(P2pSwapLv1NoblestackABI), getProviderOrSigner(library, account));
            await p2pContract.deposit(ethers.utils.parseEther(swapAmount)).then((tx: any) => {
                tx.wait().then((responce: any) => {
                    toast.success('Stake successful', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    })
                })
            })
        } catch (error) {
            showError(error);
        }
    }

    //sell GOLD 
    const sellGOLD = async () => {
        try {
            console.log(parseFloat(swapAmount) * 1000000)
            // const goldContract = new Contract(GoldAddress, new Interface(GoldTokenABI), getProviderOrSigner(library, account));
            
console.log("User entered swapAmount:", swapAmount);
        console.log("Sent to contract (units):", parseFloat(swapAmount) * 1000000);


const goldpoolContract = new Contract(PoolAddress, new Interface(GoldPoolABI), getProviderOrSigner(library, account));

            await goldpoolContract.sellGold(parseFloat(swapAmount) * 1000000).then((tx: any) => {
                tx.wait().then((responce: any) => {
                    toast.success('Sell successful', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    })
                })
            })
        } catch (error) {
            showError(error);
        }
    }


    const swap = async () => {
        try {
            // swapAddress
            // const goldtokenContract = new Contract(GoldAddress, new Interface(GoldTokenABI), getProviderOrSigner(library, account));
            const goldpoolContract = new Contract(PoolAddress, new Interface(GoldPoolABI), getProviderOrSigner(library, account));

            await goldpoolContract.buyGold(parseFloat(swapAmount) * 1000000).then((tx: any) => {
                tx.wait().then((responce: any) => {
                    toast.success('Buy successful', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    })
                })
            })

        } catch (error) {
            showError(error);
        }
    }

    const withdrawPos = async () => {
        try {
            const p2pContract = new Contract(p2pAddress, new Interface(P2pSwapLv1NoblestackABI), getProviderOrSigner(library, account));
            await p2pContract.withdraw().then((tx: any) => {
                tx.wait().then((response: any) => {
                    toast.success('Noble Stack Withdrawed', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    })
                })
            })
        } catch (error) {
            showError(error)
        }
    }

    const claimPos = async () => {
        try {
            const p2pContract = new Contract(p2pAddress, new Interface(P2pSwapLv1NoblestackABI), getProviderOrSigner(library, account));
            await p2pContract.claimReward().then((tx: any) => {
                tx.wait().then((response: any) => {
                    toast.success('Reward Claimed', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    })
                })
            })
        } catch (error) {
            showError(error)
        }
    }

    const transfer = async () => {
        try {
            const posContract = new Contract(posAddress, new Interface(LV1NobleStackABI.abi), getProviderOrSigner(library, account));
            if (!claimAddress) throw "No claim address defined"
            if (!swapAmount) throw "No amount entered to trnasfer"
            await posContract.depost(ethers.utils.parseEther(swapAmount)).then((tx: any) => {
                tx.wait().then((response: any) => {
                    toast.success('Transfer successful', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    })
                })
            })
        } catch (error) {
            showError(error)
        }
    }

    const checkApprovedUsdc = async () => {
        try {
            const usdcContract = new Contract(UsdcAdress, new Interface(ERC20ABI.abi), getProviderOrSigner(library, account));
            let allowance = await usdcContract.allowance(account, GoldAddress);
            let amount = ethers.utils.parseEther(swapAmount);
            if (Number(allowance) >= Number(amount)) {
                setApprovedUsdc(true)
            } else {
                setApprovedUsdc(false);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const checkApprovedGOLD = async () => {
        try {
            const goldContract = new Contract(GoldAddress, new Interface(ERC20ABI.abi), getProviderOrSigner(library, account));
            let allowance = await goldContract.allowance(account, GoldAddress);
            let amount = ethers.utils.parseEther(swapAmount);
            if (Number(allowance) >= Number(amount)) {
                setApprovedGOLD(true)
            } else {
                setApprovedGOLD(false);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const checkBalance = async () => {
        try {
            const posContract = new Contract(posAddress, new Interface(LV1NobleStackABI.abi), getProviderOrSigner(library, account));
            if (account) {
                const blnc = await posContract.balanceOf(account);
                const blncContract = await posContract.balanceOf(p2pAddress);
                

setBalance(Number(blnc) / 1e18);
                setContractBalance(Number(blncContract) / 1e18)
            }


        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        checkApprovedUsdc();
        checkApprovedGOLD();
    }, [swapAmount, account])

    useEffect(() => {
        checkBalance();
    }, [account, level])

   return (
    <div style={{ borderRadius: "20px", backgroundColor: "#00000080", padding: "20px 40px", border: "1px solid #daa52080", marginBottom: '1000px' }}>
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={1}>
                    <Grid item sm={12} xs={12} sx={{ marginTop: '0px',  marginBottom: '10px' }}>
                        <Box sx={{ flexGrow: 1, height: '100%', display: 'flex', flexWrap: 'wrap', alignContent: 'space-between' }}>
                            <Grid container spacing={1} className='margin-top-device'>
                                <Grid item xs={12}>
                                    <p style={{
                                        color: '#daa520',
                                        fontSize: '1.55em',
                                        letterSpacing: '.1em',
                                        textAlign: 'center'
                                    }}
                                        className='card-title'
                                    >
                                        {`TEMPLAR G✠LD SWAP`}{' '}
                                    </p>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} className='margin-top-device' >
                                <Grid item xs={12} sx={{ marginTop: '0px', marginBottom: '0px' }}>
                                    <p style={{
                                        fontSize: '1.1em',
                                        letterSpacing: '0.11em',
                                        color: '#D4AF37',
                                        textAlign: 'center'
                                    }}
                                        className='card-sub-title'
                                    >
                                        <span>{`BUY G✠LD WITH USDC`}</span>
                                    </p>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} className="margin-top-device">
                                <Grid item xs={12}>
                                    <button
                                        className="coin-button-receive"
                                        onClick={handleOpenc}
                                        style={{ background: "linear-gradient(180deg, #FEE970, #FFAD06)", color: "#000000", marginBottom: '50px'}}
                                    >
                                        {"BUY G✠LD"}
                                    </button>
                                </Grid>

                                 <Grid item xs={12} sx={{ marginTop: '0px', marginBottom: '0px' }}>
                                    <p style={{
                                        fontSize: '1.1em',
                                        letterSpacing: '0.11em',
                                        color: '#D4AF37',
                                        textAlign: 'justify'
                                    }}
                                        className='card-sub-title'
                                    >
                                        <span>{`BACKED BY GOLD: EACH TEMPLAR G+LD TOKEN IS BACKED BY PHYSICAL GOLD, SECURELY STORED IN AUDITED AND INSURED VAULTS WORLDWIDE.`}</span>
                                    </p>
                                </Grid>

                                <Grid item xs={12} sx={{ marginTop: '0px', marginBottom: '0px' }}>
                                    <p style={{
                                        fontSize: '1.1em',
                                        letterSpacing: '0.11em',
                                        color: '#D4AF37',
                                        textAlign: 'justify'
                                    }}
                                        className='card-sub-title'
                                    >
                                        <span>{`STABLE VALUE: DOLLAR-PEGGED, WITH EACH TOKEN DYNAMICALLY BALANCED TO MAINTAIN A CONSISTENT VALUE.`}</span>
                                    </p>
                                </Grid>

                                <Grid item xs={12} sx={{ marginTop: '0px', marginBottom: '0px' }}>
                                    <p style={{
                                        fontSize: '1.1em',
                                        letterSpacing: '0.11em',
                                        color: '#D4AF37',
                                        textAlign: 'justify'
                                    }}
                                        className='card-sub-title'
                                    >
                                        <span>{`REDEEMABLE & LIQUID: TOKENS CAN BE REDEEMED FOR GOLD OR SOLD FOR USD OR USDC 1 FOR 1.`}</span>
                                    </p>
                                </Grid>



                               <Grid item xs={12} sx={{ marginTop: '0px', marginBottom: '0px' }}>
                                    <p style={{
                                        fontSize: '1.1em',
                                        letterSpacing: '0.11em',
                                        color: '#D4AF37',
                                        textAlign: 'justify'
                                    }}
                                        className='card-sub-title'
                                    >
                                        <span>{`USDC ON POLYGON: PURCHASE AND SELL USING USDC ON THE POLYGON NETWORK FOR EFFICIENT, LOW-COST TRANSACTIONS.`}</span>
                                    </p>
                                </Grid>


                               <Grid item xs={12} sx={{ marginTop: '0px', marginBottom: '0px' }}>
                                    <p style={{
                                        fontSize: '1.1em',
                                        letterSpacing: '0.11em',
                                        color: '#D4AF37',
                                        textAlign: 'justify'
                                    }}
                                        className='card-sub-title'
                                    >
                                        <span>{`INSTANT SETTLEMENT: TRANSACTIONS ARE FREE FROM SETTLEMENT OR CREDIT RISK, OFFERING INSTANTANEOUS SETTLEMENT.`}</span>
                                    </p>
                                </Grid>




                                    <Grid item xs={12}>
                                    <button
                                        className="coin-button-receive coin-button-receive2"
                                        onClick={handleOpene}
                                        style={{
                                            background: '#000000bf',
                                            color: '#ffffffbf'
                                        }}
                                    >
                                        {"SELL G✠LD"}
                                    </button>
                                      </Grid>



                                <Grid item xs={12}>
                                    </Grid>
                            </Grid>
                        </Box>

                    </Grid>
                </Grid>
                <hr style={{ border: 'none', borderTop: '0px solid #6c757d', width: '100%', margin: '0px 0' }}></hr>

            </Box>


            {/* swap modal */}
            




<Modal
    aria-labelledby='transition-modal-title'
    aria-describedby='transition-modal-description'
    open={openc}
    onClose={handleClosec}
    closeAfterTransition
    BackdropComponent={Backdrop}
    BackdropProps={{
        timeout: 500,
        sx: { backgroundColor: 'rgba(0, 0, 0, 0.8)' },
    }}
>
    <Fade in={openc}>
        <Box
            className="custom-overlay"
            onClick={handleClosec}
            sx={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '16px',
            }}
        >
            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{ width: '100%', maxWidth: '400px' }}
            >

                <p style={{
    color: '#ffc600',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    letterSpacing: '0.2em',
    textAlign: 'center',
    marginBottom: '90px',
}}>
    TEMPLAR G✠LD SWAP
</p>


                <p style={{
                    color: '#ffc600',
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                    letterSpacing: '0.2em',
                    marginBottom: '24px',
                    textAlign: 'center',
                }}>
                    BUY G✠LD
                </p>

                <TextField
                    fullWidth
                    label={`AMOUNT ${swapIn}`}
                    value={swapAmount}
                    onChange={(e) => setSwapAmount(e.target.value)}
                    sx={{ mb: 5 }}
                    InputProps={{
                        style: {
                            backgroundColor: 'transparent',
                            borderRadius: '999px',
                            color: '#ffc600',
                            border: '1px solid #ffc600',
                            padding: '12px 20px',
                        },
                    }}
                    InputLabelProps={{
                        style: { color: '#ffc600' },
                    }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3 }}>
                    


<Button
    onClick={approvedUsdc ? swap : () => approveUsdc(swapAmount)}
    variant="outlined"
    sx={{
        border: '1px solid #ffc600',
        color: '#ffc600',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        borderRadius: '999px',
        px: 4,
    }}
>
    {approvedUsdc ? 'Confirm' : `Approve ${swapIn}`}
</Button>





                    <Button
                        onClick={handleClosec}
                        variant="outlined"
                        sx={{
                            border: '1px solid #ffc600',
                            color: '#ffc600',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            borderRadius: '999px',
                            px: 4,
                        }}
                    >
                        Cancel
                    </Button>
                </Box>
            </Box>
        </Box>
    </Fade>
</Modal>





            {/* Sell modal */}
            
<Modal
    aria-labelledby="transition-modal-title"
    aria-describedby="transition-modal-description"
    open={opene}
    onClose={handleClosee}
    closeAfterTransition
    BackdropComponent={Backdrop}
    BackdropProps={{
        timeout: 500,
        sx: { backgroundColor: 'rgba(0, 0, 0, 0.8)' },
    }}
>
    <Fade in={opene}>
        <Box
            className="custom-overlay"
            onClick={handleClosee}
            sx={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '16px',
            }}
        >
            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{ width: '100%', maxWidth: '400px' }}
            >
                                <p style={{
    color: '#ffc600',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    letterSpacing: '0.2em',
    textAlign: 'center',
    marginBottom: '90px',
}}>
    TEMPLAR G✠LD SWAP
</p>
                <p style={{
                    color: '#ffc600',
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                    letterSpacing: '0.2em',
                    marginBottom: '24px',
                    textAlign: 'center',
                }}>
                    SELL G✠LD
                </p>

                <TextField
                    fullWidth
                    label={`SELL AMOUNT`}
                    value={swapAmount}
                    onChange={(e) => setSwapAmount(e.target.value)}
                    sx={{ mb: 5 }}
                    InputProps={{
                        style: {
                            backgroundColor: 'transparent',
                            borderRadius: '999px',
                            color: '#ffc600',
                            border: '1px solid #ffc600',
                            padding: '12px 20px',
                        },
                    }}
                    InputLabelProps={{
                        style: { color: '#ffc600' },
                    }}
                />

                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3 }}>
                    {approvedGOLD ? (
                        <Button
                            onClick={sellGOLD}
                            variant="outlined"
                            sx={{
                                border: '1px solid #ffc600',
                                color: '#ffc600',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                borderRadius: '999px',
                                px: 4,
                            }}
                        >
                            Confirm
                        </Button>
                    ) : (
                        <Button
                            onClick={approveGOLD}
                            variant="outlined"
                            sx={{
                                border: '1px solid #ffc600',
                                color: '#ffc600',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                borderRadius: '999px',
                                px: 4,
                            }}
                        >
                            Approve G✠LD
                        </Button>
                    )}

                    <Button
                        onClick={handleClosee}
                        variant="outlined"
                        sx={{
                            border: '1px solid #ffc600',
                            color: '#ffc600',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            borderRadius: '999px',
                            px: 4,
                        }}
                    >
                        Cancel
                    </Button>
                </Box>
            </Box>
        </Box>
    </Fade>
</Modal>

        </div>
    )
}

export default memo(P2pSwapSocietyCard)
